// Pure mapper: turns the backend's canonical status shape (Phase 0, Task 4's
// mapFlightStatusResponse) into the same 2-element
// [{departure:{...}}, {arrival:{...}}] array shape the old flightapi.io raw
// response had — so FlightTracking.jsx's existing field-reads
// (departInfo.terminal, departInfo['Status:'], departInfo['scheduledTime'],
// departInfo.airportCode, arrivInfo.arrivalDateTime) need no changes.
// airportName/airportCity/airportCountryCode are ADDED relative to the old
// flightapi.io shape — they let FlightTracking.jsx's resolveFlightMeta build
// city-name/domestic-vs-international data locally instead of via a removed
// network call, since FlightNerve already returns this inline.
export const mapCanonicalStatusToLegacyLegs = canonical => {
  if (!canonical || canonical.noData) return null
  const departure = canonical.departure || {}
  const arrival = canonical.arrival || {}
  return [
    {
      departure: {
        terminal: departure.terminal ?? null,
        gate: departure.gate ?? null,
        'Status:': canonical.status || '',
        'Airport:': departure.airportCode || '',
        airportCode: departure.airportCode || '',
        airportName: departure.airport || '',
        airportCity: departure.airportCity || '',
        airportCountryCode: departure.airportCountryCode || '',
        scheduledTime: departure.scheduledTime || '',
        // RD-4144: the provider's estimate, same "HH:mm, Mon DD" shape. Applied by
        // FlightTracking as an offset to the scheduled time, never on its own.
        estimatedTime: departure.estimatedTime || '',
        // Both passed through for DURATION ONLY — never for display. The local
        // `scheduledTime` above is what the card shows.
        //
        // `departureDateTime` is the ISO string WITH the airport's offset, and it is the
        // one that already ships: it resolves to the correct UTC instant even for the
        // airports FlightNerve has no timezone for. DOH comes back as
        // 2026-08-12T22:05:00+00:00 — the offset label is wrong (Qatar is +3) but 22:05Z
        // is the right instant, because FlightNerve computed it as UTC and then stamped
        // +00:00 rather than the real offset. So the duration is correct from this alone.
        //
        // `departureDateTimeUtc` is the explicit UTC field, preferred when present. It
        // needs the rolzo-api change to ship; until then the line above carries it.
        departureDateTime: departure.actualTime || '',
        departureDateTimeUtc: departure.actualTimeUtc || '',
      },
    },
    {
      arrival: {
        terminal: arrival.terminal ?? null,
        gate: arrival.gate ?? null,
        'Airport:': arrival.airportCode || '',
        airportCode: arrival.airportCode || '',
        airportName: arrival.airport || '',
        airportCity: arrival.airportCity || '',
        airportCountryCode: arrival.airportCountryCode || '',
        scheduledTime: arrival.scheduledTime || '',
        estimatedTime: arrival.estimatedTime || '',
        arrivalDateTime: arrival.actualTime || '',
        // See the departure side: duration arithmetic only.
        arrivalDateTimeUtc: arrival.actualTimeUtc || '',
      },
    },
  ]
}
